/* eslint-disable react-hooks/exhaustive-deps */
import {
  Badge,
  Box,
  Skeleton,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { useWindowWidth } from "@react-hook/window-size";
import _ from "lodash";
import { filterOrdersByName } from "network/helper";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTranslatorProjects,
  getUnreadMessagesRequest,
} from "store/project/reducer";
import {
  isFetchingTranslatorProjectsSelector,
  translatorProjectsSelector,
  unreadMessageSelector,
} from "store/project/selector";
import { searchQuerySelector } from "store/ui/selector";
import { userSelector } from "store/user/selector";
import TranslatorProjectDetail from "./components/translatorProjectDetail";
import TranslatorProjectsMobileTable from "./components/translatorProjectsMobileTable";
import TranslatorProjectsTable from "./components/translatorProjectsTable";

export default function TranslatorProjects() {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const translatorProjects = useSelector(translatorProjectsSelector);
  console.log("tranlsatorProjects======>" , translatorProjects)
  const searchQuery = useSelector(searchQuerySelector);
  const unreadMessages = useSelector(unreadMessageSelector);
  const isFetchingTranslatorProjects = useSelector(
    isFetchingTranslatorProjectsSelector
  );
  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (user) {
      dispatch(getTranslatorProjects({ user_id: Number(user.user_id) }));
    }
  }, [user]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getUnreadMessagesRequest({ user_id: Number(user.user_id) }));
    }, 60000*10); // 10 seconds = 10000 ms

    return () => clearInterval(interval); // Cleanup on unmount
  }, [dispatch, user.user_id]);

  const categorizedProjects = useMemo(() => {
    let results: any[] = [];
    let languages: string[] = [];
    if (translatorProjects) {
      translatorProjects.forEach((it: any) => {
        if (it.translated_to) {
          languages = [...languages, ...it.translated_to.split(",")];
        }
      });

      languages = _.uniq(["all", ...languages]);

      languages.forEach((lang) => {
        let languageProjects =
          lang === "all"
            ? filterOrdersByName(translatorProjects, searchQuery)
            : filterOrdersByName(translatorProjects, searchQuery)?.filter(
                (it) =>
                  it?.translated_to
                    ?.toLowerCase()
                    .includes(lang?.toLocaleLowerCase())
              );

        let activeProjects = languageProjects
          ?.filter(
            (it) =>
            Number(it.order_status_id) <= 4
          )
          ?.map((it) => ({
            ...it,
            id: it?.order_id,
          }));

        let activeProjectsCnt = 0;
        activeProjects?.forEach((it: any) => {
          let order_id = it?.order_id;
          const cnt = Number(
            unreadMessages?.find(
              (_it: any) => Number(_it?.order_id) === Number(order_id)
            )?.cnt || 0
          );
          activeProjectsCnt += cnt;
        });

        let completedProjects = languageProjects
        ?.filter((it) => Number(it.order_status_id) == 6 || Number(it.order_status_id) == 7) //Number(it.order_status_id) === 6
          ?.map((it) => ({
            ...it,
            id: it?.order_id,
          }));

        let completedProjectsCnt = 0;
        completedProjects?.forEach((it: any) => {
          let order_id = it?.order_id;
          const cnt = Number(
            unreadMessages?.find(
              (_it: any) => Number(_it?.order_id) === Number(order_id)
            )?.cnt || 0
          );
          completedProjectsCnt += cnt;
        });

        let pastDueProjects = languageProjects
          ?.filter(
            (it) =>
              it.order_due_at &&
              new Date(it.order_due_at).getTime() < new Date().getTime() &&
              Number(it.order_status_id) < 6
          )
          ?.map((it) => ({
            ...it,
            id: it?.order_id,
            notificationType: 5,
          }));

        let pastDueProjectsCnt = 0;
        pastDueProjects?.forEach((it: any) => {
          let order_id = it?.order_id;
          const cnt = Number(
            unreadMessages?.find(
              (_it: any) => Number(_it?.order_id) === Number(order_id)
            )?.cnt || 0
          );
          pastDueProjectsCnt += cnt;
        });

        results.push({
          lang,
          activeProjects,
          completedProjects,
          pastDueProjects,
          activeProjectsCnt,
          completedProjectsCnt,
          pastDueProjectsCnt,
        });
      });
    }
    return results;
  }, [translatorProjects, searchQuery, unreadMessages]);

  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const showDetailsTranslatorProductDetails = (order_id: string) => {
    setSelectedProjectId(order_id);
  };

  return (
    <Box pt={{ base: "60px", md: "80px", xl: "80px" }}>
      {!isFetchingTranslatorProjects && categorizedProjects?.length > 0 && (
        <Tabs variant="unstyled">
          <TabList flexWrap="wrap">
            {categorizedProjects.map((it: any, index: number) => (
              <Tab
                key={index}
                padding={{
                  md: index === 0 ? "0px 20px 0px 0px" : "0px 20px",
                  sm: index === 0 ? "0px 10px 0px 0px" : "0px 10px",
                }}
                fontSize={{ md: "17px", sm: "12px" }}
                lineHeight={{ md: "24px", sm: "22px" }}
                fontWeight="400"
                alignItems="center"
                textTransform="capitalize"
                _selected={{ color: "blue.500" }}
                _focus={{ boxShadow: "none" }}
              >
                {it.lang}                 
                {Number(it?.activeProjectsCnt) +
                  Number(it?.completedProjectsCnt) + Number(it?.pastDueProjectsCnt) >
                  0 && (
                    <Badge
                      bgColor={"#F02828"}
                      sx={{
                        padding: "9px 6px !important",
                        borderRadius: "1000px",
                        fontWeight: "700",
                        fontSize: "10px",
                        lineHeight: "0px",
                        color: "#FFF",
                        marginLeft: "7px",
                        minWidth: "18px",
                      }}
                    >
                      {Number(it?.activeProjectsCnt ?? 0) +
                        Number(it?.completedProjectsCnt ?? 0) +
                        Number(it?.reviewProjectsCnt ?? 0) +
                        Number(it?.pastDueProjectsCnt)}
                    </Badge>
                  )}
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            {categorizedProjects.map((it: any, index: number) => (
              <TabPanel
                px="0"
                key={index}
                mt={{ md: "26px", base: "15px" }}
                py="0"
              >
                <Tabs variant="unstyled">
                  <TabList borderBottom={"2px solid #E9E9E9"}>
                    <Tab
                      padding={{ md: "14px 25px", sm: "5px" }}
                      fontSize={{ md: "17px", sm: "12px" }}
                      lineHeight={{ md: "24px", sm: "22px" }}
                      fontWeight="400"
                      alignItems="center"
                      _selected={{ color: "blue.500" }}
                      _focus={{ boxShadow: "none" }}
                      whiteSpace="nowrap"
                    >
                      Ongoing
                      {Number(it?.activeProjectsCnt) > 0 && (
                        <Badge
                          bgColor={"#F02828"}
                          sx={{
                            padding: "9px 6px !important",
                            borderRadius: "1000px",
                            fontWeight: "700",
                            fontSize: "10px",
                            lineHeight: "0px",
                            color: "#FFF",
                            marginLeft: "7px",
                            minWidth: "18px",
                          }}
                        >
                          {it?.activeProjectsCnt}
                        </Badge>
                      )}
                    </Tab>
                    <Tab
                      padding={{ md: "14px 25px", sm: "5px" }}
                      fontSize={{ md: "17px", sm: "12px" }}
                      lineHeight={{ md: "24px", sm: "22px" }}
                      fontWeight="400"
                      alignItems="center"
                      _selected={{ color: "blue.500" }}
                      _focus={{ boxShadow: "none" }}
                      whiteSpace="nowrap"
                    >
                      Past Due
                      {Number(it?.pastDueProjectsCnt) > 0 && (
                        <Badge
                          bgColor={"#F02828"}
                          sx={{
                            padding: "9px 6px !important",
                            borderRadius: "1000px",
                            fontWeight: "700",
                            fontSize: "10px",
                            lineHeight: "0px",
                            color: "#FFF",
                            marginLeft: "7px",
                            minWidth: "18px",
                          }}
                        >
                          {it?.pastDueProjectsCnt}
                        </Badge>
                      )}
                    </Tab>

                    <Tab
                      padding={{ md: "14px 25px", sm: "5px" }}
                      fontSize={{ md: "17px", sm: "12px" }}
                      lineHeight={{ md: "24px", sm: "22px" }}
                      fontWeight="400"
                      alignItems="center"
                      _selected={{ color: "blue.500" }}
                      _focus={{ boxShadow: "none" }}
                      whiteSpace="nowrap"
                    >
                      Completed
                      {Number(it?.completedProjectsCnt) > 0 && (
                        <Badge
                          bgColor={"#F02828"}
                          sx={{
                            padding: "9px 6px !important",
                            borderRadius: "1000px",
                            fontWeight: "700",
                            fontSize: "10px",
                            lineHeight: "0px",
                            color: "#FFF",
                            marginLeft: "7px",
                            minWidth: "18px",
                          }}
                        >
                          {it?.completedProjectsCnt}
                        </Badge>
                      )}
                    </Tab>
                  </TabList>
                  <TabIndicator
                    mt="-2px"
                    height="2px"
                    bg="blue.500"
                    borderRadius="1px"
                  />
                  <TabPanels>
                    <TabPanel px="0">
                      {windowWidth >= 768 ? (
                        <TranslatorProjectsTable
                          tableData={it.activeProjects}
                          onShowTranslatorProjectDetails={
                            showDetailsTranslatorProductDetails
                          }
                        />
                      ) : (
                        <TranslatorProjectsMobileTable
                          tableData={it.activeProjects}
                          onShowTranslatorProjectDetails={
                            showDetailsTranslatorProductDetails
                          }
                        />
                      )}
                    </TabPanel>
                    <TabPanel px="0">
                      {windowWidth >= 768 ? (
                        <TranslatorProjectsTable
                          tableData={it.pastDueProjects}
                          onShowTranslatorProjectDetails={
                            showDetailsTranslatorProductDetails
                          }
                        />
                      ) : (
                        <TranslatorProjectsMobileTable
                          tableData={it.pastDueProjects}
                          onShowTranslatorProjectDetails={
                            showDetailsTranslatorProductDetails
                          }
                        />
                      )}
                    </TabPanel>
                    <TabPanel px="0">
                      {windowWidth >= 768 ? (
                        <TranslatorProjectsTable
                          tableData={it.completedProjects}
                          onShowTranslatorProjectDetails={
                            showDetailsTranslatorProductDetails
                          }
                        />
                      ) : (
                        <TranslatorProjectsMobileTable
                          tableData={it.completedProjects}
                          onShowTranslatorProjectDetails={
                            showDetailsTranslatorProductDetails
                          }
                        />
                      )}
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      )}
      {!isFetchingTranslatorProjects && categorizedProjects?.length < 1 && (
        <Box>No Projects</Box>
      )}
      {isFetchingTranslatorProjects && (
        <Tabs>
          <TabList flexWrap="wrap">
            {_.range(4).map((it: any, index: number) => (
              <Tab
                key={index}
                padding={{
                  md: "10px 10px",
                  sm: "10px",
                }}
                fontSize={{ md: "17px", sm: "14px" }}
                lineHeight={{ md: "24px", sm: "22px" }}
                fontWeight="400"
                alignItems="center"
                textTransform="capitalize"
                _selected={{ color: "blue.500" }}
                _focus={{ boxShadow: "none" }}
              >
                <Skeleton
                  width={{ md: "100px", base: "50px" }}
                  height="20px"
                  colorScheme="#F3F5F5"
                />
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            {windowWidth >= 768 &&
              _.range(4).map((it) => (
                <TabPanel px="0" key={it}>
                  <TranslatorProjectsTable
                    isFetching={isFetchingTranslatorProjects}
                    tableData={[]}
                    onShowTranslatorProjectDetails={
                      showDetailsTranslatorProductDetails
                    }
                  />
                </TabPanel>
              ))}
            {windowWidth < 768 &&
              _.range(4).map((it) => (
                <TabPanel px="0" key={it}>
                  <TranslatorProjectsMobileTable
                    isFetching={isFetchingTranslatorProjects}
                    tableData={[]}
                    onShowTranslatorProjectDetails={
                      showDetailsTranslatorProductDetails
                    }
                  />
                </TabPanel>
              ))}
          </TabPanels>
        </Tabs>
      )}
      <TranslatorProjectDetail
        selectedProjectId={selectedProjectId}
        onCloseModal={() => {
          setSelectedProjectId(null);
        }}
      />
    </Box>
  );
}
